$(function () {

    //запускаем фоновый видос и показываем его только после того, как он полностью загрузился
    var video = document.getElementById('bg_video'),
        $preloader = $(".preloader");
    if (video) {
        if (!$("html").hasClass("mz-touchevents")) {
            video.addEventListener('error', function () {
                $preloader.addClass("preloader--hidden");
            });
            video.src = "/static/video/video.mp4";
            video.addEventListener('canplaythrough', function () {
                $preloader.addClass("preloader--hidden");
            }, false);
            if (video.readyState > 3) {
                $preloader.addClass("preloader--hidden");
            }
            setTimeout(function () {
                $preloader.addClass("preloader--hidden");
            }, 2000);
        } else {
            $preloader.addClass("preloader--hidden");
        }
    } else {
        $preloader.addClass("preloader--hidden");
    }

    //галереи
    var $gallery = $(".gallery");

    if ($gallery.length) {
        $gallery.lightGallery({
            selector: "a"
        });
    }

    //слайдер по годам
    if ($(".years_slider__wrapper").length) {

        var swiper_1 = new Swiper('.years_slider', {
            slidesPerView: 3,
            spaceBetween: 0,
            centeredSlides: true,
            noSwiping: true,
            simulateTouch: false
        });

    }

    //слайдер техники
    if ($(".equip_slider__wrapper").length) {

        var swiper_2 = new Swiper('.equip_slider', {
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            on: {
                slideChange: function () {
                    swiper_1.slideTo(this.activeIndex);
                }
            }
        });

    }

    var cards = $('.equip_slider__slide_card'),
        hover_items = $('.equip__info_item'),
        hover_pairs = {};

    cards.map(function (i, item) {
        var id = $(item).attr('data-id');
        hover_pairs[id] = {
            card: $(item),
            key: parseInt($(item).attr('data-key'))
        };
    });

    hover_items.map(function (i, item) {
        var id = $(item).attr('data-id');
        if (hover_pairs[id]) {
            hover_pairs[id]['item'] = $(item);
            hover_pairs[id].item.on('mouseenter', function (e) {
                hover_pairs[id].item.addClass('equip__info_item--visible');
            });
            hover_pairs[id].item.on('mouseleave', function (e) {
                hover_pairs[id].item.removeClass('equip__info_item--visible');
            });

            hover_pairs[id].card.on('mouseenter', function (e) {
                hover_pairs[id].item.addClass('equip__info_item--visible');
            });
            hover_pairs[id].card.on('mouseleave', function (e) {
                hover_pairs[id].item.removeClass('equip__info_item--visible');
            });
        }
    });

    // наркомания для слайдера спецтехники
    function calcPositions() {
        for (var name in hover_pairs) {
            var pair = hover_pairs[name];
            if (pair.item) {
                var widths = pair.card.width() * 7;
                var parent_width = pair.card.closest('.swiper-slide').width();
                var space = (parent_width - widths) / 6;
                var left = (pair.key * pair.card.width()) + (space * pair.key) - (pair.item.width() / 2) + (pair.card.width() / 2);
                var padding = window.innerWidth > 1199 ? 0 : 85;
                padding = window.innerWidth > 991 ? padding : 30;
                pair.item.css({
                    left: left + padding,
                    top: (window.innerWidth > 1199 ? -140 : -90)
                })
            }
        }
    }

    calcPositions();
    $(window).on('resize', function () {
        console.log('recalculate positions');
        calcPositions();
    });

    //слайдер продукции
    if ($(".production_slider__wrapper").length) {

        var swiper_3 = new Swiper('.production_slider', {
            slidesPerView: 1,
            spaceBetween: 0,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            }
        });

    }


    //табы
    if ($(".tabs").length) {

        $(".tabs__categories").find("> .tabs__categories_item:eq(0)").addClass("tabs__categories_item--current");

        $(".tabs__categories .tabs__categories_item").click(function (g) {
            var tab = $(this).closest(".tabs"),
                index = $(this).closest(".tabs__categories_item").index();

            tab.find(".tabs__categories > .tabs__categories_item").removeClass("tabs__categories_item--current");
            $(this).closest(".tabs__categories_item").addClass("tabs__categories_item--current");

            tab.find(".tabs__content").find(".tabs__content_item").not(".tabs__content_item:eq(" + index + ")").slideUp(0);
            tab.find(".tabs__content").find(".tabs__content_item:eq(" + index + ")").slideDown(0);

            g.preventDefault();
        });

    }

});
